import React from "react";
import Link from "gatsby-link";
import glamorous from "glamorous";
import { withCookies } from "react-cookie";

import FeatureButton from "../FeatureButton";

const CookieNoticeContainer = glamorous.div(({ theme }) => ({
  alignItems: "center",
  background: "#fff",
  borderRadius: "22.5pt",
  boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
  display: "flex",
  fontSize: "12pt",
  padding: "0 18pt",
  transition: "0.25s",
  // height and width is set to match FB Customer Chat Icon
  height: "45pt",
  minWidth: "45pt",
  maxWidth: "calc(100% - 18pt - 45pt - 18pt - 18pt)",
  position: "fixed",
    left: "18pt",
    bottom: "18pt",
  [theme.main.mediaQueries.desktop]: {
    maxWidth: "50%"
  },
  "@media (min-width: 1150px) and (max-width: 1350px)": {
    maxWidth: "60%"
  },
  "@media (max-width: 1150px)": {
    height: "90px",
    maxWidth: "60%"
  },
  "@media (max-width: 850px)": {
    height: "unset",
    flexDirection: "column",
    padding: "18pt"
  }
}));

const EmailButton = glamorous(FeatureButton)(({ theme }) => ({
  background: theme.main.colors.waterLight,
  boxShadow: "0px 2px 5px rgba(0,0,0,0.1)",
  color: theme.main.colors.ocean,
  fontSize: 16,
  marginLeft: "0.35rem",
  padding: "0.35rem 0.75rem",
  textAlign: "center",
  ":hover": {
    background: "#fff",
    color: theme.main.colors.ocean,
  },
  "@media (max-width: 850px)": {
    textAlign: "center",
    marginTop: "1rem",
    width: "50%"
  },
}));

class CookieNotice extends React.Component {
  constructor (props) {
    super();
    this.cookieKey = "privacyPolicyAccepted";
    this.cookieValue = "1";
    this.state = {
      isOpen: !(props.cookies.get(this.cookieKey) === this.cookieValue)
    };
  }

  acceptPrivacyPolicy = () => {
    this.props.cookies.set(this.cookieKey, this.cookieValue);
    this.setState({
      isOpen: false
    });
  }

  render () {
    if (!this.state.isOpen) {
 return null; 
}
    return (
      <CookieNoticeContainer>
        <p style={{ marginBottom: 0 }}>Manta Equipment uses cookies to give you the best possible experience. To use our website, you must agree to our <Link to="/privacy">Privacy Policy</Link>, including our cookie policy.</p>
        <EmailButton onClick={this.acceptPrivacyPolicy}>Agree</EmailButton>
      </CookieNoticeContainer>
    );
  }
}

export default withCookies(CookieNotice);



// WEBPACK FOOTER //
// ./src/components/CookieNotice/index.js